import { IntegrationsModel, IntegrationOrganizationItemModel } from "../../models/integrations.model";

export class SetIntegrations {
	static readonly type = '[GlobalConfig][Generic Integration] SetIntegrations';
	constructor(public integrations: IntegrationsModel[]) {}
}

export class SetIntegration {
	static readonly type = '[GlobalConfig][Generic Integration] SetIntegration';
	constructor(public integration: IntegrationsModel) {}
}

export class SetIntegrationMenu {
	static readonly type = '[GlobalConfig][Generic Integration] SetIntegrationMenu';
	constructor(public integration: string, public reload = false) {}
}

export class SetIntegrationOrganization {
	static readonly type = '[GlobalConfig][Generic Integration] SetIntegrationOrganization';
	constructor(public organization: IntegrationOrganizationItemModel) {}
}

export class ClearIntegrationOrganization {
	static readonly type = '[GlobalConfig][Generic Integration] ClearIntegrationOrganization';
}

export class SetIntegrationOrganizationMenu {
	static readonly type = '[GlobalConfig][Generic Integration] SetIntegrationOrganizationMenu';
}

export class ClearIntegrationOrganizationMenu {
	static readonly type = '[GlobalConfig][Generic Integration] ClearIntegrationOrganizationMenu';
}

export class SetIntegrationBackUrl {
	static readonly type = '[GlobalConfig][Generic Integration] SetIntegrationBackUrl';
	constructor(public url: string) {}
}

export class ClearSelectedIntegration {
	static readonly type = '[GlobalConfig][Generic Integration] ClearSelectedIntegration';
}
